import React, { createContext } from 'react';

interface CheckItOutContextValue {
  isCheckItOutTreatment: boolean;
}

const CheckItOutContext = createContext<CheckItOutContextValue>({
  isCheckItOutTreatment: false
});

const CheckItOutProvider: React.FC<
  React.PropsWithChildren<{ isCheckItOutTreatment: boolean }>
> = ({ isCheckItOutTreatment, children }) => {
  return (
    <CheckItOutContext.Provider value={{ isCheckItOutTreatment }}>
      {children}
    </CheckItOutContext.Provider>
  );
};

export default CheckItOutContext;
export { CheckItOutProvider };
